import type { GlobalSearchResult, ModuleSearchAdapter } from "../types";
import { getSearchClient } from "../apiClient";
import { globalSearchScopeStore } from "../scope";

interface EmailFromAddress {
  name?: string;
  email: string;
}

interface EmailSearchHit {
  id: string;
  thread_id: string;
  subject: string;
  from: EmailFromAddress[];
  preview: string;
  received_at: string;
  has_attachment?: boolean;
  is_read?: boolean;
}

interface EmailSearchResponse {
  count: number;
  results: EmailSearchHit[];
}

function fromLabel(from: EmailFromAddress[]): string {
  const first = from[0];
  if (!first) return "";
  return first.name && first.name.length > 0 ? first.name : first.email;
}

function mapHit(h: EmailSearchHit): GlobalSearchResult {
  return {
    id: `email:${h.thread_id}`,
    moduleId: "email",
    title: h.subject,
    subtitle: `${fromLabel(h.from)} · ${h.preview}`,
    timestamp: h.received_at,
    href: `/email/thread/${h.thread_id}`,
  };
}

export const emailAdapter: ModuleSearchAdapter = {
  moduleId: "email",
  label: "Email",
  async search(q, signal) {
    const mailboxId = globalSearchScopeStore.getState().emailMailboxId;
    const mailboxQs = mailboxId ? `&mailbox=${encodeURIComponent(mailboxId)}` : "";
    const res = await getSearchClient().get<EmailSearchResponse>(
      `/api/email/email/search/?q=${encodeURIComponent(q)}&limit=3${mailboxQs}`,
      { signal },
    );
    return res.results.map(mapHit);
  },
};
